import type { OptionsObject } from "notistack";

export const ToastOptions: Partial<OptionsObject> = {
    autoHideDuration: 3000,
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
    persist: false,
    preventDuplicate: true,
}